import { render, staticRenderFns } from "./LottieDemo.vue?vue&type=template&id=dc185d1c&scoped=true&"
import script from "./LottieDemo.vue?vue&type=script&lang=js&"
export * from "./LottieDemo.vue?vue&type=script&lang=js&"
import style0 from "./LottieDemo.vue?vue&type=style&index=0&id=dc185d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc185d1c",
  null
  
)

export default component.exports